import React from 'react';
import {useMutation} from '@tanstack/react-query';

import {serverRegistry} from 'springboard-server/src/register';
import {getUserFromHonoContext} from '../../../packages/springboard/auth/better-auth/better_auth_server_module';
import {nodeRpcAsyncLocalStorage} from '@springboardjs/platforms-node/services/node_rpc_async_local_storage';
import {createPresignedUrlForWritingFile, createMultipartUpload, createMultipartUploadPartUrl, completeMultipartUpload, abortMultipartUpload} from '../files/remote_files/remote_files_server';
import {generateId} from '../../store/utils/generate_id';
import crypto from 'crypto';
import {FullDB} from '../../../packages/enterprise/src/store/db/all_server_migrations';
import springboard from 'springboard';
import {getCurrentUserContext} from '@/store/selectors/selectors';
import {useSelectorWithRefresh} from '@/store/kysely_module';

declare module 'springboard/module_registry/module_registry' {
    interface AllModules {
        UploaderUrls: UploaderUrlsModuleReturnValue;
    }
}

type UploaderUrlsModuleReturnValue = {

};

springboard.registerModule('UploaderUrls', {}, async (moduleAPI): Promise<UploaderUrlsModuleReturnValue> => {
    const actions = moduleAPI.createActions({
        createUploaderUrl: async (args: {project_id: string, workspace_id: string}) => {
            
        }
    });


    moduleAPI.registerRoute('', {}, () => {
        const [selectedWorkspaceId, setSelectedWorkspaceId] = React.useState<string>('');
        const [selectedProjectId, setSelectedProjectId] = React.useState<string>('');
        const [createdUrl, setCreatedUrl] = React.useState<string | null>(null);

        const [workspaces] = useSelectorWithRefresh('getAllWorkspaces', {}, [], {workspace_id: null});
        const [projects] = useSelectorWithRefresh('getProjectsForWorkspace', {workspace_id: selectedWorkspaceId || '', topLevelOnly: true, includeHidden: false}, [], {workspace_id: selectedWorkspaceId || ''});

        const createUploaderUrlMutation = useMutation({
            mutationFn: async () => {
                if (!selectedProjectId || !selectedWorkspaceId) {
                    throw new Error('Project and workspace must be selected');
                }
                return await actions.createUploaderUrl({
                    project_id: selectedProjectId,
                    workspace_id: selectedWorkspaceId,
                });
            },
            onSuccess: (result) => {
                const baseUrl = window.location.origin;
                const uploaderUrl = `${baseUrl}/uploader-urls/${result.token}/upload-url`;
                setCreatedUrl(uploaderUrl);
            },
            onError: (error) => {
                console.error('Failed to create uploader URL:', error);
                alert('Failed to create uploader URL');
            },
        });

        const handleCreateUrl = () => {
            createUploaderUrlMutation.mutate();
        };

        return (
            <div style={{padding: '2rem', maxWidth: '600px'}}>
                <h2>Create Uploader URL</h2>
                <div style={{marginTop: '1rem'}}>
                    <label htmlFor="workspace-select" style={{display: 'block', marginBottom: '0.5rem'}}>
                        Select Workspace:
                    </label>
                    <select
                        id="workspace-select"
                        value={selectedWorkspaceId}
                        onChange={(e) => {
                            setSelectedWorkspaceId(e.target.value);
                            setSelectedProjectId('');
                        }}
                        style={{
                            width: '100%',
                            padding: '0.5rem',
                            marginBottom: '1rem',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                        }}
                    >
                        <option value="">-- Select a workspace --</option>
                        {workspaces.map((workspace) => (
                            <option key={workspace.id} value={workspace.id}>
                                {workspace.name}
                            </option>
                        ))}
                    </select>

                    <label htmlFor="project-select" style={{display: 'block', marginBottom: '0.5rem'}}>
                        Select Project:
                    </label>
                    <select
                        id="project-select"
                        value={selectedProjectId}
                        onChange={(e) => setSelectedProjectId(e.target.value)}
                        disabled={!selectedWorkspaceId}
                        style={{
                            width: '100%',
                            padding: '0.5rem',
                            marginBottom: '1rem',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            cursor: selectedWorkspaceId ? 'pointer' : 'not-allowed',
                            opacity: selectedWorkspaceId ? 1 : 0.6,
                        }}
                    >
                        <option value="">-- Select a project --</option>
                        {projects.map((project) => (
                            <option key={project.id} value={project.id}>
                                {project.name}
                            </option>
                        ))}
                    </select>

                    <button
                        onClick={handleCreateUrl}
                        disabled={!selectedProjectId || !selectedWorkspaceId || createUploaderUrlMutation.isPending}
                        style={{
                            padding: '0.5rem 1rem',
                            backgroundColor: selectedProjectId && selectedWorkspaceId && !createUploaderUrlMutation.isPending ? '#228be6' : '#ccc',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: selectedProjectId && selectedWorkspaceId && !createUploaderUrlMutation.isPending ? 'pointer' : 'not-allowed',
                        }}
                    >
                        {createUploaderUrlMutation.isPending ? 'Creating...' : 'Create Uploader URL'}
                    </button>
                </div>

                {createdUrl && (
                    <div style={{
                        marginTop: '2rem',
                        padding: '1rem',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '4px',
                    }}>
                        <h3>Uploader URL Created!</h3>
                        <p style={{wordBreak: 'break-all', fontFamily: 'monospace', fontSize: '0.9rem'}}>
                            {createdUrl}
                        </p>
                        <button
                            onClick={() => navigator.clipboard.writeText(createdUrl)}
                            style={{
                                marginTop: '0.5rem',
                                padding: '0.5rem 1rem',
                                backgroundColor: '#40c057',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                            }}
                        >
                            Copy to Clipboard
                        </button>
                    </div>
                )}
            </div>
        );
    });

    return {};
});


